<template>
  <v-app-bar app color="#204281" height="70px">
    <div class="d-flex align-center logo-wrapper" @click="goToHome">
      <v-img
        alt="Maxicash Logo"
        class="shrink"
        contain
        src="../assets/common/maxicash-logo.png"
        transition="scale-transition"
        height="100%"
      />
    </div>

    <v-spacer></v-spacer>
    <div>
      <!-- <label class="btn-1">Account</label> -->
      <label class="btn-1">Sign In</label>
    </div>
  </v-app-bar>
</template>

<script>
export default {
  name: "Header",

  methods: {
    goToHome() {
      this.$router.push("/dashboard").catch(() => {});
    },
  },
};
</script>

<style>
.btn-1 {
  cursor: pointer;
  font-size: 12px;
  color: white;
  margin-right: 50px;
}

.logo-wrapper {
  padding: 5px;
  margin-left: 25px;
  height: 100%;
  width: 150px;
  cursor: pointer;
}

@media only screen and (max-width: 460px) {
  .btn-1 {
    font-size: 11px;
    margin-right: 20px;
  }

  .logo-wrapper {
    margin-left: 0;
    width: 120px;
  }
}
</style>
